import AXIOS from "../services/axios";
import { workBoardAPIList } from "../constants/apiURL";

export const getTaskTypes = async () => {
  const response = { result: null, err: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/list/task-type/`,
    );
    response.result = data;
  } catch (err) {
    response.err = err.response || err;
  }
  return response;
};

export const getTasks = async (
  project,
  cohort,
  property,
  member,
  initial,
  header,
  currPage,
  dateFilters,
  type,
  noLink,
  sortOption = null,
) => {
  const response = { data: null, error: null };

  try {
    const url = workBoardAPIList.GET_TASKS(
      project,
      cohort,
      property,
      member,
      dateFilters,
      type,
      header,
      currPage,
      noLink,
      sortOption,
    );
    const { data } = await AXIOS.get(url);
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getIndividualTask = async (id) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/workboard2/${id}`,
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getTaskHistory = async (id) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/list/task-history/?task=${id}`,
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getCohortList = async () => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/list/cohort`,
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getFormatList = async () => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/list/format`,
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getStatusList = async () => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/list/task-status`,
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getCategoryList = async () => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/dropdown/category`,
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const addTask = async (
  id,
  topic,
  post_link,
  due_date,
  caption,
  cohort,
  format,
  category,
  status,
  members,
  approvers,
  state,
  project,
  property,
  action,
  igPostLink,
  ytPostLink,
) => {
  const response = {
    status: null,
    message: null,
    error: null,
  };
  const obj = {
    title: topic,
    post_link: post_link,
    ig_post_link: igPostLink,
    yt_post_link: ytPostLink,
    due_at: due_date,
    description: caption,
    assigned_to: members,
    approvers: approvers,
    status: status?.id ? status?.id : "",
    cohort: cohort?.id ? cohort?.id : "",
    format: format?.id ? format?.id : "",
    state: state?.id ? state?.id : null,
    category: category?.id ? category?.id : null,
    project: project?.id ? project?.id : "",
    property: property?.id ? property?.id : "",
    // attachments: [],
  };
  if (action === "create") {
    obj.attachments = [];
  }
  try {
    if (action === "edit") {
      const { data } = await AXIOS.patch(
        `${process.env.REACT_APP_API_PATH}/tasks2/${id}/`,
        obj,
      );
      response.status = data;
      response.message = data;
    } else {
      const { data } = await AXIOS.post(
        `${process.env.REACT_APP_API_PATH}/tasks2/`,
        obj,
      );
      response.status = data;
      response.message = data;
    }
  } catch (err) {
    response.error = err.response.status;
    response.message = err?.response?.data?.detail;
  }
  return response;
};

export const editTaskStatus = async (id, status) => {
  const response = {
    data: null,
    error: null,
  };
  const obj = {
    status: status,
  };
  try {
    const { data } = await AXIOS.patch(
      `${process.env.REACT_APP_API_PATH}/tasks2/${id}/`,
      obj,
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const addAttachment = async (
  id,
  base,
  platform,
  type,
  checkedPlatform,
) => {
  let platformKey = {
    facebook: 3,
    instagram: 1,
    youtube: 2,
  };

  const response = {
    status: null,
    message: null,
    error: null,
  };

  const selectedPlatforms = Object.keys(checkedPlatform)
    .filter((key) => checkedPlatform[key]) // Platforms selected in checkedPlatform
    .concat(platform ? [platform] : []) // Add platform if provided
    .filter((value, index, self) => self.indexOf(value) === index); // Remove duplicates

  // Map the selected platforms to their keys
  const category = selectedPlatforms.map((p) => platformKey[p]).filter(Boolean);

  const obj = {
    entity: 0,
    entity_id: id,
    aws_file_ids: [base],
    categories: category,
    category: "facebook",
    subcategory: type,
  };
  try {
    const { data } = await AXIOS.post(
      `${process.env.REACT_APP_API_PATH}/uploads/`,
      obj,
    );
    response.status = data;
    response.message = data;
  } catch (err) {
    response.error = err;
  }
  return response;
};

export const getAttachmentsList = async (id, type, attach_id, status) => {
  const response = { data: null, error: null };
  let obj = {};
  if (type === "edit") {
    obj[`approved_status`] = status;
  }

  try {
    if (type === "del") {
      const { data } = await AXIOS.delete(
        `${process.env.REACT_APP_API_PATH}/uploads/${attach_id}?entity=0&entity_id=${id}`,
      );
      response.data = data;
    } else if (type === "edit") {
      const { data } = await AXIOS.patch(
        `${process.env.REACT_APP_API_PATH}/uploads/${attach_id}/?entity=0&entity_id=${id}`,
        obj,
      );
      response.data = data;
    } else {
      const { data } = await AXIOS.get(
        `${process.env.REACT_APP_API_PATH}/uploads/?entity=0&entity_id=${id}`,
      );
      response.data = data;
    }
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getTaskAttachmentsAPI = async (id) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/uploads/?entity=0&entity_id=${id}`,
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const addComment = async (id, text, type, action, commentId) => {
  const response = {
    status: null,
    message: null,
    error: null,
  };
  const obj = {
    task: id,
    text: text,
    // attachment: [],
    type: type,
  };
  try {
    if (action === "create") {
      const { data } = await AXIOS.post(
        `${process.env.REACT_APP_API_PATH}/comments/`,
        obj,
      );
      response.status = data;
      response.message = data;
    } else {
      const { data } = await AXIOS.patch(
        `${process.env.REACT_APP_API_PATH}/comments/${commentId}/`,
        obj,
      );
      response.status = data;
      response.message = data;
    }
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const addAttachmentComment = async (
  id,
  text,
  type,
  action,
  commentId,
) => {
  const response = {
    status: null,
    message: null,
    error: null,
  };
  const obj = {
    attachment: id,
    text: text,
    type: type,
  };
  try {
    if (action === "create") {
      const { data } = await AXIOS.post(
        `${process.env.REACT_APP_API_PATH}/comments/`,
        obj,
      );
      response.status = data;
      response.message = data;
    } else {
      const { data } = await AXIOS.patch(
        `${process.env.REACT_APP_API_PATH}/comments/${commentId}/`,
        obj,
      );
      response.status = data;
      response.message = data;
    }
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const deleteComment = async (id, commentId, type) => {
  const response = {
    status: null,
    message: null,
    error: null,
  };
  const obj = {
    status: 0,
  };
  if (type === "attachment") {
    obj[`attachment`] = id;
  } else {
    obj[`task`] = id;
  }
  try {
    const { data } = await AXIOS.patch(
      `${process.env.REACT_APP_API_PATH}/comments/${commentId}/`,
      obj,
    );
    response.status = data;
    response.message = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getCommentsList = async (id, type) => {
  const response = { data: null, error: null };
  if (type === "attachment") {
    try {
      const { data } = await AXIOS.get(
        `${process.env.REACT_APP_API_PATH}/comments/?attachment=${id}`,
      );
      response.data = data;
    } catch (err) {
      response.error = err.response;
    }
  } else {
    try {
      const { data } = await AXIOS.get(
        `${process.env.REACT_APP_API_PATH}/comments/?task=${id}`,
      );
      response.data = data;
    } catch (err) {
      response.error = err.response;
    }
  }
  return response;
};

export const publishContent = async (
  fileIds,
  type,
  description,
  taskId,
  title,
  schedule_date,
  platform,
  thumbnailId,
  pageId,
) => {
  const response = { data: null, error: null };
  let formattedTime = null;
  if (schedule_date) {
    const date = new Date(schedule_date);
    formattedTime = date.toISOString();
  }

  let obj = {
    task: taskId,
    message: description,
    title: "",
    post_type: type,
    attachments: fileIds,
    platform: platform,
    thumbnail: thumbnailId,
    scheduled_time: formattedTime,
    x_app_token: `${process.env.REACT_APP_VIDEO_SECRECT_KEY}`,
    ...(pageId ? { page_id: pageId } : {}),
  };
  if (type === 2) {
    obj.title = title;
  }

  try {
    const { data } = await AXIOS.post(
      `${process.env.REACT_APP_API_PATH}/fbupload/post`,
      obj,
    );
    response.data = data;
  } catch (err) {
    response.error = err?.response?.data?.detail;
  }
  return response;
};

export const getYoutubeAuth = async (taskId) => {
  const response = { data: null, error: null };

  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/fbupload/youtube/auth?task_id=${taskId}`,
    );
    response.data = data;
  } catch (err) {
    response.error = err?.response?.data?.detail;
  }

  return response;
};

export const getYoutubeAuthStatus = async (taskId) => {
  const response = { data: null, error: null };

  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/fbupload/youtube/authstatus?task_id=${taskId}`,
    );
    response.data = data;
  } catch (err) {
    response.error = err?.response?.data?.detail;
  }

  return response;
};

export const publishYoutubeContent = async (
  fileIds,
  type,
  description,
  taskId,
  title,
  schedule_date,
  thumbnailId,
) => {
  const response = { data: null, error: null };
  let formattedTime = null;
  if (schedule_date) {
    const date = new Date(schedule_date);
    formattedTime = date.toISOString();
  }

  let obj = {
    task: taskId,
    message: description,
    title: title,
    post_type: type, // video
    attachments: fileIds,
    platform: 4, // YouTube
    thumbnail: thumbnailId || "",
    scheduled_time: formattedTime,
    privacy_status: "public", // Default as specified
    categoryId: 22, // Default as specified
    x_app_token: `${process.env.REACT_APP_VIDEO_SECRECT_KEY}`,
  };

  try {
    const { data } = await AXIOS.post(
      `${process.env.REACT_APP_API_PATH}/fbupload/ytpost`,
      obj,
    );
    response.data = data;
  } catch (err) {
    response.error = err?.response?.data?.detail;
  }
  return response;
};

export const createTaskAPI = async (taskData) => {
  const response = {
    data: null,
    error: null,
  };
  try {
    const { data } = await AXIOS.post(
      `${process.env.REACT_APP_API_PATH}/tasks2/`,
      taskData,
    );
    response.data = data;
  } catch (err) {
    response.error = err?.response?.data?.detail;
  }
  return response;
};

export const updateTaskAPI = async (id, data) => {
  const response = {
    data: null,
    error: null,
  };
  try {
    const { data: resData } = await AXIOS.patch(
      `${process.env.REACT_APP_API_PATH}/tasks2/${id}/`,
      data,
    );
    response.data = resData;
  } catch (err) {
    response.error = err?.response?.data?.detail;
  }
  return response;
};

export const updateTaskWithStatusAPI = async (id, data) => {
  const response = {
    data: null,
    error: null,
  };
  try {
    const { data: resData } = await AXIOS.patch(
      `${process.env.REACT_APP_API_PATH}/post-link-update/${id}/`,
      data,
    );
    response.data = resData;
  } catch (err) {
    response.error = err?.response?.data?.detail;
  }
  return response;
};

export const getCommentAndScriptAPI = async (taskId) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/comments/?task=${taskId}`,
    );
    response.data = data;
  } catch (err) {
    response.error = err?.response;
  }
  return response;
};

export const addCommentOrScriptAPI = async (taskId, type, text) => {
  const response = {
    data: null,
    error: null,
  };
  const obj = {
    task: taskId,
    text,
    type,
  };
  try {
    const { data } = await AXIOS.post(
      `${process.env.REACT_APP_API_PATH}/comments/`,
      obj,
    );
    response.data = data;
  } catch (err) {
    response.error = err?.response;
  }
  return response;
};

export const editCommentOrScriptAPI = async (id, text) => {
  const response = {
    data: null,
    error: null,
  };
  const obj = {
    text,
  };
  try {
    const { data } = await AXIOS.patch(
      `${process.env.REACT_APP_API_PATH}/comments/${id}/`,
      obj,
    );
    response.data = data;
  } catch (err) {
    response.error = err?.response;
  }
  return response;
};

export const deleteCommentOrScriptAPI = async (id) => {
  const response = {
    data: null,
    error: null,
  };
  const obj = {
    status: 0,
  };
  try {
    const { data } = await AXIOS.patch(
      `${process.env.REACT_APP_API_PATH}/comments/${id}/`,
      obj,
    );
    response.data = data;
  } catch (err) {
    response.error = err?.response;
  }
  return response;
};

export const getTaskHistoryAPI = async (taskId) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/list/task-history/?task=${taskId}`,
    );
    response.data = data;
  } catch (err) {
    response.error = err?.response;
  }
  return response;
};

export const setAttachmentApprovalStatusAPI = async (
  taskId,
  attachmentId,
  status,
) => {
  const response = {
    data: null,
    error: null,
  };
  const obj = {
    approved_status: status,
  };
  try {
    const { data } = await AXIOS.patch(
      `${process.env.REACT_APP_API_PATH}/uploads/${attachmentId}/?entity=0&entity_id=${taskId}`,
      obj,
    );
    response.data = data;
  } catch (err) {
    response.error = err?.response;
  }
  return response;
};

export const getTaskBasicDetailsAPI = async (taskId) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/reposearch/taskbasicdetails/${taskId}/`,
    );
    response.data = data;
  } catch (err) {
    response.error = err?.response;
  }
  return response;
};
